import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class CodeStandardDocumentTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (CodeStandardDocumentTypeModel._instance == null) CodeStandardDocumentTypeModel._instance = new CodeStandardDocumentTypeModel(authManager);
        return CodeStandardDocumentTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'standards/code-standard-document-types', 'standards/code-standard-document-types/codelist');

        this.entityName = 'standards.CodeStandardDocumentType';
        this.privileges = {
            create: [["adminStandards"]],
            read: [["adminStandards"],["manageStandards"],["editStandards"],["readStandards"]],
            update: [["adminStandards"]],
            delete: [["adminStandards"]],
        };

        this.label = 'Cds Type';
        this.setLabel = 'Cds Types';

        this.browser = {
            name: 'default-standards-codestandarddocumenttype-browser',
            moduleName: 'default-standards-codestandarddocumenttype-browser',
            moduleTitle: 'Cds Types',
            moduleStateSlotName: 'default-standards-codestandarddocumenttype-browser',
        };

        this.editor = {
            name: 'default-standards-codestandarddocumenttype-editor',
            moduleName: 'default-standards-codestandarddocumenttype-editor',
            moduleTitle: 'Cds Type',
            moduleStateSlotName: 'default-standards-codestandarddocumenttype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
